import { useIntl } from 'react-intl';

import { useCarousel } from '../../../../design-system/components/carousel/Carousel';
import { Scale, Typography } from '../../../../design-system/components/typography/Typography';
import { Carousel } from '../../../../domains/Layout/Carousel/Carousel';
import { Destination } from '../../../../resources/destination/domain/types/destination';
import { PointOfInterest } from '../../../../resources/pointOfInterest/domain/types/PointOfInterest';
import { PointOfInterestCard } from '../../../../shared/components/PointOfInterestCard/PointOfInterestCard';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';

import style from './PointOfInterestCarousel.module.css';

type PointOfInterestCarouselProps = {
    pointsOfInterest: Array<
        PickDomain<
            PointOfInterest,
            'id' | 'slug' | 'name' | 'geolocation',
            {
                destination: PickDomain<Destination, 'slug'>;
                averageRating: PointOfInterest['averageRating'] | null;
                picture: PointOfInterest['picture'] | null;
                description: PointOfInterest['description'] | null;
            }
        >
    >;
    scale?: Scale;
};

export function PointOfInterestCarousel({
    pointsOfInterest,
    scale = 'secondary-m-bold',
}: PointOfInterestCarouselProps) {
    const { formatMessage } = useIntl();
    const carouselProps = useCarousel();

    return (
        <div>
            <Typography as="h2" className={style.title} scale={scale}>
                {formatMessage({ id: 'global.poiToVisit.carrouselTitle' })}
            </Typography>

            <Carousel
                {...carouselProps}
                slidesVisibleRules={{
                    sm: 2,
                    md: 2,
                    lg: 3,
                    xl: 4,
                    xxl: 4,
                }}
                trackingInformation={{
                    navClick: {
                        block: 'places',
                    },
                }}
            >
                {pointsOfInterest.map((pointOfInterest, index) => {
                    return (
                        <PointOfInterestCard
                            key={pointOfInterest.id}
                            pointOfInterest={pointOfInterest}
                            trackingInformation={{
                                click: {
                                    block: 'places',
                                    click_type: 'card',
                                    card_number: index + 1,
                                },
                            }}
                        />
                    );
                })}
            </Carousel>
        </div>
    );
}
